import { StoreExt } from '@utils/reactExt'
import { action, observable } from 'mobx'
import _ from 'lodash'
import { USER_REPORT_TYPE } from '@v2/constants/common'
import { IReportCreate } from '@protocol/report'

export class ReportStore extends StoreExt {

  @observable
  selectedReportTextList: string[] = []

  @action
  setSelectedText(selectedText: string): void {
    this.selectedReportTextList.push(selectedText)
  }

  @action
  removeSelectedText(selectedText: string): void {
    const index = _.indexOf(this.selectedReportTextList, selectedText)
    if (index > -1) {
      _.pullAt(this.selectedReportTextList, [index])
    }
  }

  @action
  resetAllState(): void {
    this.selectedReportTextList = []
  }

  @action
  createReport = async (params: {
    reportType: USER_REPORT_TYPE, targetId: string, targetUserPromiseId: string,
  }): Promise<IReportCreate.Schema> => {
    const { reportType, targetId, targetUserPromiseId } = params
    try {
      if (_.isEmpty(this.selectedReportTextList)) {
        return null
      }
      if (_.isNil(targetId)) {
        return null
      }
      if (_.isNil(reportType)) {
        return null
      }
      const params = {
        reportTextList: this.selectedReportTextList,
        reportType,
        targetId,
        targetUserPromiseId,
      }
      return await this.api.report.createReport(params)
    } catch (err) {
      console.error(err)
    }
  }
}

export default new ReportStore()
